/* list of available premium-games types availables in Loyalty, 
must be a sublist of gameTypeNames in premium-games repo */
export const gameTypeNames = ['predictions'] as const;
export type GameTypeName = (typeof gameTypeNames)[number];

export const gameTypeToUrlPrefix = {
  predictions: 'predictions-app',
} satisfies { [key in GameTypeName]: string };

export interface PremiumGameType {
  id: number;
  name: GameTypeName;
  url: string;
}

export interface PremiumGameMetadata {
  loader?: {
    backgroundColor?: string;
  };
  progressBar?: {
    color?: string;
  };
  size?: {
    width?: number;
    height?: number;
    mobileHeight?: number;
  };
}

export interface PremiumGame {
  id: number;
  /** Identifier stored on the advanced format widget as its config id. */
  uuid: string;
  name: string;
  isTemplate: boolean;
  type: PremiumGameType;
  createdAt: string;
  updatedAt: string;
  tenantId?: string;
  parentId?: number;
  isActive: boolean;
  isCrossTenant: boolean;
  screenshot?: string;
  metadata?: PremiumGameMetadata;
  order?: number;
}
